// Widget Scripts
import customTicketButton from './js/widgets/customTicketButton.js';
import slideshow from './js/widgets/slideshow.js';
import autoEvent from './js/widgets/autoEvent.js';
import cardWidget from './js/widgets/cardWidget.js';
import seoWidget from './js/widgets/seoWidget.js';
import videoWidget from './js/widgets/videoWidget.js';
import staticManagedSponsors from './js/widgets/staticManagedSponsors.js';
import scrollerSponsors from './js/widgets/scrollerSponsors.js';
import gallery from './js/widgets/gallery.js';

// Custom Theme Scripts
import './js/localjs.js';

// Initialize Homepage Widgets
$(document).ready(function () {
  customTicketButton();
  staticManagedSponsors('affiliateLogos', affiliateLogosOpts, 'Proudly Associated with', 3);
  if (globalThis.location.pathname === '/') {
    slideshow();
    autoEvent();
    cardWidget();
    seoWidget();
    staticManagedSponsors('premiumSponsors', premiumSponsorsOpts, 'Premium Sponsors', 5);
    scrollerSponsors();
    gallery();
    $(globalThis).load(function () {
      videoWidget();
    });
  }
});
